import {Component, EventEmitter, Input, Output} from '@angular/core';
import {PasswordService} from "../../../_services/password.service";
import {PasswordUtil} from "../x-models/password-util";
import {Side} from "../x-models/x-enums/side";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {CrossCheckDisplayComponent} from "../cross-check-display/cross-check-display.component";

@Component({
  selector: 'app-password-entry',
  templateUrl: './password-entry.component.html',
  imports: [
    CommonModule,
    FormsModule,
    CrossCheckDisplayComponent
  ],
  styleUrls: ['./password-entry.component.scss']
})
export class PasswordEntryComponent {
  pattern = new RegExp('^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$');
  upper = new RegExp('(?=.*[A-Z])');
  lower = new RegExp('(?=.*[a-z])');
  special = new RegExp('(?=.*[!@#$&*])');
  numbers = new RegExp('(?=.*[0-9])');

  @Input() PasswordUtil: PasswordUtil = new PasswordUtil();
  @Output() PasswordUtilChange = new EventEmitter<PasswordUtil>();

  @Input() OldPasswordEntry: boolean = true;
  @Input() DarkMode: boolean = false;
  protected readonly Side = Side;

  constructor(private passwordService: PasswordService) {

  }

  CheckUpper(): boolean {
    return this.upper.test(this.PasswordUtil.password);
  }

  CheckLower(): boolean {
    return this.lower.test(this.PasswordUtil.password);
  }

  CheckSpecial(): boolean {
    return this.special.test(this.PasswordUtil.password);
  }

  CheckNumbers(): boolean {
    return this.numbers.test(this.PasswordUtil.password);
  }

  CheckLength(): boolean {
    return this.PasswordUtil.password.length >= 8 && this.PasswordUtil.password.length <= 32
  }

  CheckAll(): boolean {
    return this.pattern.test(this.PasswordUtil.password);
  }

  CompareConfirmation(): boolean {
    return this.PasswordUtil.password == this.PasswordUtil.confirmation;
  }

  Validate() {
    this.PasswordUtil.valid = this.PasswordUtil.password == this.PasswordUtil.confirmation && this.CheckAll();
    this.PasswordUtilChange.emit(this.PasswordUtil);
  }
}
